import { useState } from 'react';

import { VisitDiagnoses } from '~libs.shared.visit';

import { HistoricalVisit } from './HistoricalVisit';
import { HistoricalVisits } from './HistoricalVisits';

type HistoricalVisitsSidePanelContentSlotProps = {
   readonly patientId: number;
   readonly currentVisitId: number;
   readonly visitDiagnoses: VisitDiagnoses;
};
export const HistoricalVisitsSidePanelContentSlot = (props: HistoricalVisitsSidePanelContentSlotProps): JSX.Element => {
   const [activeHistoricalVisitId, setActiveHistoricalVisitId] = useState<number | undefined>();

   const onGoBackLinkClick = (): void => {
      setActiveHistoricalVisitId(undefined);
   };

   const onVisitItemClick = (visitId: number): void => {
      setActiveHistoricalVisitId(visitId);
   };

   return activeHistoricalVisitId ? (
      <HistoricalVisit
         onGoBackLinkClick={onGoBackLinkClick}
         patientId={props.patientId}
         visitId={activeHistoricalVisitId}
         targetVisitId={props.currentVisitId}
         visitDiagnoses={props.visitDiagnoses}
      />
   ) : (
      <HistoricalVisits
         patientId={props.patientId}
         currentVisitId={props.currentVisitId}
         onVisitItemClick={onVisitItemClick}
      />
   );
};

export type HistoricalVisitsSidePanelContentSlotType = (
   props: HistoricalVisitsSidePanelContentSlotProps
) => JSX.Element;
